import { useCallback } from 'react';

type UseTopLevelTabLoopFocusOptions = {
  containerRef: React.RefObject<HTMLElement | null>;
  isEnabled: boolean;
  activeTabSelector?: string;
};

export const useTopLevelTabLoopFocus = ({
  containerRef,
  isEnabled,
  activeTabSelector = 'button[tabindex="0"]',
}: UseTopLevelTabLoopFocusOptions) => {
  const focusActiveTab = useCallback(() => {
    if (!isEnabled) {
      return;
    }

    const activeTabButton = (containerRef.current?.querySelector(
      activeTabSelector
    ) ||
      containerRef.current?.querySelector(
        'button[tabindex="0"]'
      )) as HTMLButtonElement | null;

    activeTabButton?.focus();
  }, [containerRef, isEnabled, activeTabSelector]);

  const handleTabLoopSentinelFocus = useCallback(() => {
    focusActiveTab();
  }, [focusActiveTab]);

  return {
    focusActiveTab,
    handleTabLoopSentinelFocus,
  };
};
